import {combineReducers} from '@reduxjs/toolkit';
import {apiReducers} from './api-reducers.ts';
import authSession from './auth-session/auth-session-slice.ts';

const rootReducer = combineReducers({
  ...apiReducers,
  authSession,
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;
